
/**
 * Import node modules.
 */
// import smoothscroll from 'smoothscroll-polyfill';
// smoothscroll.polyfill();

/**
 * Require other JS libraries.
 */
const WebFont = require('webfontloader');
// const scrollDirection = require('./libs/jpScrollDirection.js');
const headerHeight = require('./utility/header-height');



// https://github.com/typekit/webfontloader
WebFont.load({
	typekit: { id: 'kwq5zpe' },
	custom: {
    families: [
			'HafferSQXH-Bold',
			'HafferSQXH-BoldItalic',
			'Iconly',
		],
    urls: [
			script_data.stylesheet_directory_uri + '/assets/fonts/fonts.css',
			script_data.stylesheet_directory_uri + '/assets/fonts/iconly.min.css',
		],
  },
	// CALLBACK FOR WHEN FONTS LOAD (OPTIONAL)
	// active: spendhq_fonts_active_cb
});

// Callback function for when the fonts are loaded.
function spendhq_fonts_active_cb() {

}





/**
 * Require JS for template parts.
 */
// Components
var header_js = require('./components/header.js');
var searchFilters_js = require('./components/search-filters.js');
var announcementBar_js = require('./components/announcement-bar.js');
var facetwp_js = require('./components/facetwp.js');

// Templates
